import queryString from 'query-string';
import { paxios } from 'util/axiosprgs';

export const swrFetcher = ([url, params]) =>
  paxios
    .get(url, {
      params,
      paramsSerializer: (params) => {
        if (!params) return;
        return queryString.stringify(params);
      },
    })
    .then((res) => res.data);

export const swrPostFetcher = ([url, params]) => paxios.post(url, params).then((res) => res.data);

export const swrMutator = (url: string, { arg }: { arg: unknown }) => paxios.post(url, arg);
